module.exports = __webpack_public_path__ + "img/cord_length.adfd4b67.png";